import Icon, { IconProps } from 'approot/shared/icons/icon';
import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/navigation/nav-school-bag-active.svg';

const IconNavSchoolBagActive = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconNavSchoolBagActive;
